module.exports = __webpack_public_path__ + "img/favicon.79c2e3e.png";